import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'ck-ui';
import { useMedia } from 'react-use';
import { usePromotionView } from '../hooks';
import { getPromoName, trackPromotionClick } from '../utils';
import styles from './Heros.module.scss';

const HeroWithVideo = ({ blockHeroVideo, handle, position, isFromContentBlock }) => {
  const videoRef = useRef(null);
  const { desktopVideo, mobileVideo, trackingID } = blockHeroVideo;
  const [isPlaying, setIsPlaying] = useState(false);
  const isMobile = useMedia('(max-width: 767px)');
  const videoUrl = isMobile ? mobileVideo : desktopVideo;
  const promo = {
    id: handle,
    name: getPromoName(handle, trackingID || videoUrl),
    position: `${handle}-${position}`
  };
  const playVideo = () => {
    videoRef.current.play();
    setIsPlaying(true);
    trackPromotionClick(promo);
  };
  const pauseVideo = () => {
    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  usePromotionView([promo], videoRef);

  const videoContent = (
    <div
      role="button"
      tabIndex="0"
      className={styles.wrapper}
      onClick={pauseVideo}
    >
      <video
        preload="auto"
        controls={isPlaying}
        playsInline
        ref={videoRef}
        aria-label="landing page video"
        className={styles.video}
      >
        <source src={isFromContentBlock ? `${videoUrl}` : `${videoUrl}#t=0.001`} type="video/mp4" />
      </video>

      {!isPlaying && (
        <Icon
          name="play"
          className="home-video-play-btn"
          size="exLarge"
          color="secondary"
          onClick={playVideo}
        />
      )}
    </div>
  );

  if (isFromContentBlock) {
    return (
      <>
        {videoContent}
      </>
    );
  }

  return (
    <section className="home-section">
      <div className="container">
        {videoContent}
      </div>
    </section>
  );
};

HeroWithVideo.propTypes = {
  blockHeroVideo: PropTypes.object.isRequired,
  handle: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  isFromContentBlock: PropTypes.bool
};

HeroWithVideo.defaultProps = {
  isFromContentBlock: false
};

export { HeroWithVideo };
